exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".image[data-v-673b212b]{height:100px}.column-div[data-v-673b212b]{width:80%;margin:0 auto}", ""]);

// exports
